const googleAuthUrl = process.env.VUE_APP_AUTH_GOOGLE_URL

export const googleSignUpManagerUrl = companyName => `${googleAuthUrl}/signup/company?name=${encodeURI(companyName)}`
export const googleSignUpUserUrl = verifyKey => `${googleAuthUrl}/signup/team-member?key=${verifyKey}`
export const googleSignInUrl = `${googleAuthUrl}/login`

export const termsOfServiceUrl = process.env.VUE_APP_TERMS_OF_SERVICE_URL
export const privacyPolicyUrl = process.env.VUE_APP_PRIVACY_POLICY
